"use client";

import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { LazyImage } from "src/components/common/lazy-image/LazyImage";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import ArrowIcon from "assets/svg/chevron_right_black.svg";

import styles from "./styles.module.css";

const ImageSlider = ({ images = [], index, url, ga4EventParameters }) => {
  const swiperRef = useRef(null);

  const goToNext = () => {
    swiperRef.current.slideNext();
  };

  const goToPrev = () => {
    swiperRef.current.slidePrev();
  };

  const onclickProjectNameGtmEvent = () => {
    setTimeout(() => {
      Ga4WithEventParameters(
        {
          eventName: "form",
          eventParameters: { ...ga4EventParameters, label: "click||project_image" },
        },
        300
      );
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [swiperRef.current]);

  return (
    <div className={styles.slider}>
      <div className={styles.imageContainer}>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className={styles.customSwiper}
          loop={true}
          spaceBetween={10}
          slidesPerView={1}
          navigation={false}
          modules={[Navigation]}
        >
          {images.map((image, i) => (
            <SwiperSlide key={i}>
              {i !== 0 || index > 1 ? (
                <a href={url} onClick={onclickProjectNameGtmEvent}>
                  <LazyImage src={image} alt="Proje Fotoğrafı" className={styles.image} />
                </a>
              ) : (
                <a href={url} onClick={onclickProjectNameGtmEvent}>
                  <img src={image} alt="Proje Fotoğrafı" className={styles.image} />
                </a>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button onClick={goToPrev} className={`${styles.button} ${styles.prev}`}>
        <ArrowIcon className={styles.iconRight} />
      </button>
      <button onClick={goToNext} className={`${styles.button} ${styles.next}`}>
        <ArrowIcon className={styles.iconLeft} />
      </button>
    </div>
  );
};

ImageSlider.propTypes = {
  images: PropTypes.array,
  index: PropTypes.number,
  url: PropTypes.string,
  ga4EventParameters: PropTypes.object,
};

export default ImageSlider;
